import React, { Component } from 'react';
import SeatNum from './seatNum';

class SeatContainer extends Component {
    state = {
        Sitnum : this.props.Sitnum
    };     
    render() {
        console.log("SeatContainer:"+this.props.Sitnum);
        return (
            <div className="student-number d-flex flex-column justify-content-center align-items-center m-auto">
                <span>좌석번호</span>
                <SeatNum Sitnum={this.props.Sitnum}/>
            </div>
        );
    }
}

export default SeatContainer;